import React from 'react'
import Title from './../../../components/typography/title.component'
import TicketSaleSelectors from '../../../ducks/ticket-sale/ticket-sale.selectors'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { PAYMENT_METHODS } from '../../../constants'

class TicketSaleTitleComponent extends React.Component {
	render() {
		if (this.props.isConfirmationStep) {

			const isBankSlip = this.props.paymentMethod === PAYMENT_METHODS.BANKSLIP

			const isPix = this.props.paymentMethod === PAYMENT_METHODS.PIX
			
			if (isBankSlip || isPix)
				return <Title hideLogo={true}>Pedido realizado com sucesso!</Title>

			return <Title hideLogo={true}>Compra realizada com sucesso!</Title>
		} else return ''
	}
}

const mapStateToProps = (store) => ({
	isConfirmationStep: TicketSaleSelectors.isConfirmationStep(store),
	paymentMethod: store.ticketSale.paymentMethod,
})

const TicketSaleTitle = withRouter(
	connect(mapStateToProps)(TicketSaleTitleComponent)
)

export default TicketSaleTitle
